module.exports = __webpack_public_path__ + "images/dark-page-bg.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dark-page-bg.png
// module id = 1066
// module chunks = 17